import ComponentCard from "../../../components/common/ComponentCard";
import PageMeta from "../../../components/common/PageMeta";
import Button from "../../../components/ui/button/Button";
import { useNavigate } from "react-router-dom";
import WorkflowsTable from "./WorkflowsTable";

const WorkFlows = () => {
  const navigate = useNavigate();

  return(
    <>
      <PageMeta 
        title="Workflows - WorkFlows | Hospitality Genie"
        description="Workflows - WorkFlows"
      />
      <div className="space-y-6">
      <ComponentCard title="Workflows - WorkFlows">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">WorkFlows</div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
                className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium text-[#ffffed] rounded-lg bg-[#142900] hover:bg-[#e1ffb4] hover:text-[#142900]"
              >
                Filter Options
              </button>
            <Button
              className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-lg bg-[#142900] hover:bg-[#3d5e42]" size="sm" 
              onClick={() => navigate('/add-new-workflow')}
            >
              Add New Workflow
            </Button>
            </div>
          </div>
        
        <div>
          {/* Table Component */}
            <WorkflowsTable />
        </div>
      </ComponentCard>
      </div>
    </>
  );

}

export default WorkFlows;